export default {"src":"/_next/static/media/OUST.337dd71b.svg","height":18,"width":18};